module.exports = __webpack_public_path__ + "assets/img/jindutiao2.06c24d10.png";